export default {
    title: "立即更新教师帐户，赚取丰富现金劵!",
    joinedTitle: "您已成功参加更新教师帐户活动！",    
    joinedMessage: "📧 奖赏将于完成更新及经教城核实后，预计数星期内发放到您的学校电邮信箱。处理需时，感谢您的耐心等候。",
    referralCode: "您的推荐码：",
    numberOfReferrals: "成功推荐人数：",
    components: {
        start: {
            description: "轻松完成资料核实，即可参与活动，赚取丰富现金券！流程简单快捷，立即行动，解锁专属教师礼遇！",
            wrongAccountAlert: "你目前登入的帐户为<b>个人教师帐户</b>。<br>如欲参与此活动，请以<b>校本教师帐户</b>重新登入。<br>如忘记校本帐户登入资讯，请联络所属学校行政人员。",
            requirement: {
                title: "参加条件",
                list: [
                    "<b>订阅教城资讯</b> – 最少剔选一项",
                    "<b>填写教师身分资料</b> – 三个必填栏位：主要任教科目、主要校内职务、关注项目​",
                ]
            },
            reward: {
                title: "优惠券机制",
                list: [
                    "每位完成更新的老师：<b>$20 7-11 现金券</b>",
                ]
            },
            referral: {
                title: "推荐制度​",
                list: [
                    "完成验证后获得独立推荐码​",
                    "每成功推荐 <b>3</b> 人完成验证，额外获 <b>$10 7-11 现金券​</b>",
                    "每位推荐人上限：成功推荐 <b>9</b> 人（最多获 $30）"
                ]
            },
            period:{
                title: "活动日期：",
                list: [
                    "{startDate} 至 {endDate}"
                ]
            }
        },
        
        referral: {
            description: "输入推荐人的推荐码，以享受相关优惠。若没有推荐码，您可直接按下一步。",
            input: {
                referralCode: {
                    label: "推荐码(选填)",
                    error:{
                       improper: "推荐码无效，请重新输入。",
                       invalid: "推荐码格式错误，请确认后再试。",
                    }   
                },
            }
        },
        subscription:{
            description: "请选择您想订阅的教城资讯，至少选择一项以继续参加活动。",
        },        
        subjects:{
            description: "请选择您填写教师身分资料中的「主要任教科目」以继续参加活动。",
        },        
        duties:{
            description: "请选择您填写教师身分资料中的「主要校内职务」以继续参加活动。",
        },        
        interests:{
            description: "请选择您填写教师身分资料中的「关注项目​」以继续参加活动。",
        },
        finish:{
            message: "完成!",
            errorMessage: "发生错误，请稍后再试。",
            shareMessage: "立即分享给其他老师，邀请他们一起参加活动，解锁更多奖赏！​",            
            share: {
                copy:{
                    title: "已复制推荐码",
                },
                copyLink:{
                    title: "已复制推荐连结",
                },
                instantMessage:{
                     title: "立即更新香港教育城（教城）校本教师帐户，赚取丰富现金券！",
                    content: "只需轻松完成资料核实，即可参与活动，赚取现金券。流程简单快捷，立即行动，解锁专属教师礼遇！​推荐码: "
                },
                email: {
                subject: "{fullname} 想邀请您于教城更新教师帐户，赚取丰富现金劵",
                content: "您好! \n \n 我想邀请您于香港教育城（教城）更新教师帐户，赚取丰富现金劵。请点击以下连结，登入校本教师帐户后即可更新教师帐户：\n {campaignLink} ",
                },
            },
        }
    },
    button: {
        join: "立即参加",
        skip: "跳过",
        share: "分享推荐码",
        cancel: "取消",
        next: "下一步",
        copy:"复制邀请连结",
        email: "电邮邀请",
        close: "关闭",
        learnMore: "了解活动详情​",         
        loginAgain: "重新登入"
    },
    stepTitle: {
        referree: "推荐码",
        subscription: "订阅教城资讯",
        teacherProfile: "填写教师身分资料",            
        questionnaire: "问卷调查",
        complete: "完成",   
    },
    
  questionnaire: {
    other: "其他",
    errors: {
      required: "此问题为必填项。",
      otherRequired: "请填写其他项内容。",
    },
    groups: [
      {
        title: "一、对教城活动或服务的认识程度",
        questions: [
          {
            title: "1. 请评估您对以下教城活动或服务的认识程度（1分为完全不了解，5分为非常了解）",
            subtitle: "项目",
            options: [
              { label: "学与教博览（LTE）" },
              { label: "「数字教育教师专业培训」系列内的研讨会或工作坊" },
              { label: "教学资源库（RD）" },
              { label: "网上学习、教学与评估平台（STAR）" },
              { label: "网上试题学习平台（OQB）" },
              { label: "Go e-Learning" },
              { label: "数字教育资源网站" },
              { label: "一站式教育科技平台（EdMarket）" },
              { label: "电子学习配套计划（eLAFP）" },
              { label: "PICCKS 学生奖励计划" },
              { label: "国民身份认同应用程序设计比赛（NI）" },
              { label: "创意演说比赛（CSC）" },
              { label: "学生创新大赛（SIC）" },
              { label: "香港阅读城" },
              { label: "e悦读学校计划" },
              { label: "小校园" },
              { label: "教城教师应用程序「EdCity Teacher」" },
              { label: "教城学生应用程序「EdCity Student」" },
              { label: "教城家长应用程序「EdCity Parent」" },
              { label: "家长讲座" }
            ]
          }
        ]
      },
      {
        title: "二、满意度",
        questions: [
          {
            title: "2. 您对教城现有的活动及服务是否满意？",
            options: [
              { label: "非常满意" },
              { label: "满意" },
              { label: "一般" },
              { label: "不满意" },
              { label: "非常不满意" }
            ]
          }
        ]
      },
      {
        title: "三、学生服务与活动期望",
        questions: [
          {
            title: "3. 您希望教城为学生提供哪些主题的活动或服务？（可选多项）",
            groups: [
              {
                subtitle: "科技与数字素养",
                options: [
                  { label: "AI／人工智能基础与应用" },
                  { label: "编程／运算思维" },
                  { label: "网络安全／数字公民素养" },
                  { label: "多媒体创作（影片、动画、网页设计等）" },
                  { label: "机械人／STEM／STEAM" }
                ]
              },
              {
                subtitle: "学术与语言",
                options: [
                  { label: "科学探究" },
                  { label: "数学思维" },
                  { label: "阅读及写作" },
                  { label: "语言学习（如英语及普通话）" }
                ]
              },
              {
                subtitle: "未来规划与价值观",
                options: [
                  { label: "升学辅导" },
                  { label: "国民身份认同／中华文化" },
                  { label: "理财教育" },
                  { label: "价值观教育（坚毅、诚信、责任感等）" }
                ]
              },
              {
                subtitle: "身心健康",
                options: [
                  { label: "心理健康／情绪管理" },
                  { label: "体育" },
                  { label: "健康饮食与生活" }
                ]
              },
              {
                subtitle: "其他",
                options: []
              }
            ]
          },
          {
            title: "4. 您希望教城未来采用哪些形式举办学生活动？（可选多项）",
            groups: [
              {
                subtitle: "在线形式",
                options: [
                  { label: "网上工作坊" },
                  { label: "网上研讨会" },
                  { label: "网上比赛" },
                  { label: "自学课程（影片／教材）" }
                ]
              },
              {
                subtitle: "线下形式",
                options: [
                  { label: "实体工作坊" },
                  { label: "实体讲座" },
                  { label: "比赛" },
                  { label: "企业参观（本地）" },
                  { label: "企业参观（内地／海外）" },
                  { label: "户外学习日" }
                ]
              },
              {
                subtitle: "混合及其他形式",
                options: [
                  { label: "在线＋线下混合模式" },
                  { label: "游戏化学习活动" },
                  { label: "模拟体验（如模拟社会及模拟法庭）" }
                ]
              },
              {
                subtitle: "其他",
                options: []
              }
            ]
          }
        ]
      },
      {
        title: "四、教师专业发展活动期望",
        questions: [
          {
            title: "5. 您对以下哪些主题的教师专业发展活动感兴趣？（可选多项）",
            groups: [
              {
                subtitle: "教学与科技",
                options: [
                  { label: "AI 教学工具与应用" },
                  { label: "教育科技趋势与创新" },
                  { label: "AI 数字素养" },
                  { label: "数据分析与评估" },
                  { label: "电子学习资源设计" }
                ]
              },
              {
                subtitle: "专业技能提升",
                options: [
                  { label: "课程设计与开发" },
                  { label: "创新教学法（如自主学习及翻转教室）" },
                  { label: "评估与考评策略" },
                  { label: "教师管理" },
                  { label: "学校行政管理" },
                  { label: "教育政策与发展" }
                ]
              },
              {
                subtitle: "学生支援",
                options: [
                  { label: "课堂管理" },
                  { label: "心理健康／学生辅导" },
                  { label: "生涯规划教育" },
                  { label: "特殊教育（SEN）" }
                ]
              },
              {
                subtitle: "价值与视野",
                options: [
                  { label: "国民教育／国家安全" },
                  { label: "媒体与信息素养" },
                  { label: "国际视野" },
                  { label: "教师身心灵健康（如压力管理及工作生活平衡）" }
                ]
              },
              {
                subtitle: "其他",
                options: []
              }
            ]
          },
          {
            title: "6. 您对以下哪些活动形式感兴趣？（可选多项）",
            groups: [
              {
                subtitle: "线下形式",
                options: [
                  { label: "实体工作坊" },
                  { label: "实体讲座／研讨会" },
                  { label: "本地企业参观及交流" },
                  { label: "内地企业参观及交流" },
                  { label: "学界同工交流分享会" },
                  { label: "方案展示日" }
                ]
              },
              {
                subtitle: "在线形式",
                options: [
                  { label: "网上研讨会" },
                  { label: "网上工作坊" },
                  { label: "自学课程（影片／教材）" }
                ]
              },
              {
                subtitle: "混合及其他形式",
                options: [
                  { label: "在线＋线下混合模式" },
                  { label: "教师社群小组" }
                ]
              },
              {
                subtitle: "其他",
                options: []
              }
            ]
          }
        ]
      },
      {
        title: "五、开放式意见（可选填）",
        questions: [
          {
            title: "7. 您对教城未来的活动或服务有甚么建议或想法？"
          }
        ]
      }
    ]
  }
}